import { useEffect, useState } from 'react';
import { getCookie } from '@/utils/general/cookie';
import useStatsigExperiment from '@/hooks/statsig/useStatsigExperiment';


const useVariant = ({experiment = '', cookieValue="", experimentParameter="variants", defaultVariant='v1'}) => {
    const [variant, setVariant] = useState("")
    let { variant: statsigVariant,experimentFailedOnPrevPage,failedToFetchWithinCutoff,loading } = useStatsigExperiment({
        experimentName: experiment,
        experimentParameter,
        defaultVariant,
    })
    useEffect(() => {
        if (!loading) {
            if (getCookie(cookieValue)) {
                setVariant(getCookie(cookieValue))
            } else {
                if (failedToFetchWithinCutoff || experimentFailedOnPrevPage) {
                    setVariant(defaultVariant)
                } else {
                    setVariant(statsigVariant || "")
                }
            }
        }
    }, [statsigVariant, loading])
    return {loading,variant,experimentFailedOnPrevPage,failedToFetchWithinCutoff}
}

export default useVariant;